"use client";

// Use `domAnimation` instead of `domMax`. `domAnimation` covers all the
// features actually used on this site (entrance animations) at roughly 25KB
// gzipped vs ~35KB+ for `domMax`. `domMax` only adds drag and layout-animation
// primitives, and a repo-wide grep confirmed neither feature is used.
//
// NOTE: we intentionally do NOT enable `strict` here yet. Strict mode throws
// whenever a descendant renders `motion.*` (the full, non-tree-shakeable
// component) instead of `m.*`. Several components still in the layout subtree
// use `motion.*` (ContactModal, FooterSection's dependents, shop modals,
// etc.), so flipping strict on would break contact-modal flows in production.
// Migrating those files from `motion.*` to `m.*` is a worthwhile follow-up
// that will unlock another bundle-size win, but it's a separate refactor.
import { LazyMotion, domAnimation } from "framer-motion";
import { LeadgenRuntime } from "@/components/leadgen/leadgen-runtime";
import { IdleMount } from "@/components/ui/idle-mount";

export function Providers({ children }: { children: React.ReactNode }) {
    return (
        <LazyMotion features={domAnimation}>
            {/*
              LeadgenRuntime runs coupon auto-apply (useInksoftCouponAutoApply).
              It has no LCP role, so defer mount behind requestIdleCallback to
              keep its hydration cost off the critical path / TBT.
            */}
            <IdleMount>
                <LeadgenRuntime />
            </IdleMount>
            {children}
        </LazyMotion>
    );
}
